import React, { useEffect, useState } from "react";
import api from "../../api";
import { toast } from "sonner";
import { TextField } from "./Field";
import FileUpload from "./FileUpload";
import { Save, Plus, Trash2 } from "lucide-react";

export default function ContentManager() {
  const [data, setData] = useState(null);
  useEffect(() => { api.getContent().then(setData).catch(() => {}); }, []);
  if (!data) return <p className="text-white/40">Загрузка...</p>;

  const hero = data.hero || {};
  const setHero = (k, v) => setData((p) => ({ ...p, hero: { ...p.hero, [k]: v } }));
  const setArr = (key, i, k, v) => setData((p) => { const a = [...(p[key] || [])]; a[i] = { ...a[i], [k]: v }; return { ...p, [key]: a }; });
  const addArr = (key, item) => setData((p) => ({ ...p, [key]: [...(p[key] || []), item] }));
  const delArr = (key, i) => setData((p) => ({ ...p, [key]: p[key].filter((_, idx) => idx !== i) }));

  const save = async () => {
    try { await api.updateContent({ hero: data.hero, stats: data.stats, steps: data.steps, reviews: data.reviews }); toast.success("Тексты главной сохранены"); }
    catch { toast.error("Ошибка сохранения"); }
  };

  const Section = ({ title, children }) => (
    <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-5"><h3 className="font-bold mb-4">{title}</h3>{children}</div>
  );

  return (
    <div className="space-y-5">
      <Section title="Главный блок (герой)">
        <div className="grid md:grid-cols-2 gap-4">
          <TextField label="Бейдж (надпись сверху)" value={hero.badge} onChange={(v) => setHero("badge", v)} />
          <TextField label="Заголовок — строка 1" value={hero.titleLine1} onChange={(v) => setHero("titleLine1", v)} />
          <TextField label="Заголовок — акцент" value={hero.titleAccent} onChange={(v) => setHero("titleAccent", v)} />
          <TextField label="Заголовок — строка 2" value={hero.titleLine2} onChange={(v) => setHero("titleLine2", v)} />
          <div className="md:col-span-2"><TextField label="Подзаголовок" textarea value={hero.subtitle} onChange={(v) => setHero("subtitle", v)} /></div>
          <div className="md:col-span-2"><FileUpload label="Главное изображение (файл)" kind="image" value={hero.image} onChange={(v) => setHero("image", v)} /></div>
          <TextField label="Карточка — заголовок" value={hero.cardTitle} onChange={(v) => setHero("cardTitle", v)} />
          <TextField label="Карточка — подпись" value={hero.cardSubtitle} onChange={(v) => setHero("cardSubtitle", v)} />
        </div>
      </Section>

      <Section title="Статистика">
        <div className="space-y-3">
          {(data.stats || []).map((s, i) => (
            <div key={i} className="flex gap-3 items-end">
              <TextField label="Значение" value={s.value} onChange={(v) => setArr("stats", i, "value", v)} />
              <TextField label="Подпись" value={s.label} onChange={(v) => setArr("stats", i, "label", v)} />
              <button onClick={() => delArr("stats", i)} className="p-2.5 text-white/40 hover:text-red-400"><Trash2 size={16} /></button>
            </div>
          ))}
          <button onClick={() => addArr("stats", { value: "", label: "" })} className="flex items-center gap-1.5 text-sm text-[#d6ff71]"><Plus size={15} /> Добавить</button>
        </div>
      </Section>

      <Section title="Блок «Почему HairMama»">
        <div className="space-y-3">
          {(data.steps || []).map((s, i) => (
            <div key={i} className="rounded-xl border border-white/10 p-3 flex gap-3 items-start">
              <div className="flex-1 grid md:grid-cols-3 gap-3"><TextField label="Заголовок" value={s.title} onChange={(v) => setArr("steps", i, "title", v)} /><div className="md:col-span-2"><TextField label="Текст" value={s.text} onChange={(v) => setArr("steps", i, "text", v)} /></div></div>
              <button onClick={() => delArr("steps", i)} className="p-2.5 text-white/40 hover:text-red-400 mt-5"><Trash2 size={16} /></button>
            </div>
          ))}
          <button onClick={() => addArr("steps", { title: "", text: "" })} className="flex items-center gap-1.5 text-sm text-[#d6ff71]"><Plus size={15} /> Добавить преимущество</button>
        </div>
      </Section>

      <Section title="Отзывы">
        <div className="space-y-3">
          {(data.reviews || []).map((r, i) => (
            <div key={i} className="rounded-xl border border-white/10 p-3 flex gap-3 items-start">
              <div className="flex-1 grid md:grid-cols-3 gap-3"><TextField label="Имя" value={r.name} onChange={(v) => setArr("reviews", i, "name", v)} /><TextField label="Роль" value={r.role} onChange={(v) => setArr("reviews", i, "role", v)} /><TextField label="Текст отзыва" value={r.text} onChange={(v) => setArr("reviews", i, "text", v)} /></div>
              <button onClick={() => delArr("reviews", i)} className="p-2.5 text-white/40 hover:text-red-400 mt-5"><Trash2 size={16} /></button>
            </div>
          ))}
          <button onClick={() => addArr("reviews", { name: "", role: "", text: "" })} className="flex items-center gap-1.5 text-sm text-[#d6ff71]"><Plus size={15} /> Добавить отзыв</button>
        </div>
      </Section>

      <div className="sticky bottom-4"><button onClick={save} className="flex items-center gap-2 rounded-full bg-[#ff3798] px-7 py-3 font-semibold hover:bg-[#ff5aac] transition-colors shadow-[0_10px_28px_-10px_rgba(255,55,152,0.9)]"><Save size={18} /> Сохранить все тексты</button></div>
    </div>
  );
}
